import { render } from "./UserCard.vue?vue&type=template&id=0db75d14&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"

import "./UserCard.vue?vue&type=style&index=0&id=0db75d14&lang=scss&scoped=true"
import "./UserCard.vue?vue&type=style&index=1&id=0db75d14&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db75d14"]])

export default __exports__